<template>
    <div class="dialog-wrapper">
        <div class="body">
            <div class="header">
            </div>
            <div class="box">
                <p class="title">公告</p>
<!--                <p class="info">规格：{{ weight }}</p>-->
                <p class="info" v-html="description"></p>
            </div>
            <div class="btn" @click="$emit('close')">确定</div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "RuleInfoDialog",

        props: {
            width: String,
            weight: String,
            description: String,
        },
    }
</script>

<style lang="scss" scoped>
    .dialog-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 100;

    }


    .body {
        background: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 101;
        width: 80%;
        border-radius: 5px;
    }

    .header {
        width: 100%;
        height: 110px;
        background: url("../assets/model.png") no-repeat;
        background-size: 100% 110px;
        margin-top: -50px;
    }

    .box {
        /*height: 20rem;*/
        overflow: auto;
        padding: 15px 20px;
        .title {
            color: #ea2d53;
            font-size: 1rem;
        }
        .info{
            text-align: left;
            font-size: 0.8rem;
            white-space: pre-wrap;
        }
    }

    .btn {
        width: 100%;
        background: #ffffff;
        color: #ea2d53;
        border: 1px solid coral;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

</style>